import { render } from "./VatSettings.vue?vue&type=template&id=354b63db&scoped=true"
import script from "./VatSettings.vue?vue&type=script&lang=js"
export * from "./VatSettings.vue?vue&type=script&lang=js"

import "./VatSettings.vue?vue&type=style&index=0&id=354b63db&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354b63db"]])

export default __exports__